import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import FrontLayout from '../layouts/FrontLayout.vue'
import { useAuthStore } from '../stores/auth.js'

const routes = [
    {
        path: '/pay/crypto/:token',
        name: 'Crypto Payment Checkout',
        meta: { auth: false, title: 'Crypto Payment' },
        component: () => import('@/views/public/CryptoPaymentCheckout.vue'),
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            auth: false,
            title: 'Login',
        },
        component: () => import('@/views/front/login.vue'),
    },
    {
        path: '/',
        // name:'Home',
        component: FrontLayout,
        // redirect: '/dashboard',
        // meta: { title: 'Querry App' },
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                meta: { title: 'Dashboard' },
                component: () =>
                    import(/* webpackChunkName: "dashboard" */ '@/views/front/home.vue'),
            },
            {
                path: '/bank',
                name: 'Bank',
                meta: { title: 'Bank' },
                redirect: '/bank/index',
                children: [
                    {
                        path: 'index',
                        name: 'Index Bank',
                        component: () => import('@/views/front/bank/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'CreateBank',
                        component: () => import('@/views/front/bank/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'UpdateBank',
                        component: () => import('@/views/front/bank/create.vue'),
                    },
                ],
            },
            {
                path: '/merchant_readiness',
                name: 'Merchant Readiness',
                meta: { auth: true, title: 'Merchant Readiness' },
                component: () => import('@/views/front/merchantReadiness/index.vue'),
            },
            {
                path: '/merchant_setup',
                name: 'Merchant Setup',
                meta: { auth: true, title: 'Merchant Setup' },
                component: () => import('@/views/front/merchantSetup/index.vue'),
            },
            {
                path: '/merchant',
                name: 'Merchant',
                redirect: '/merchant/index',
                meta: { title: 'Merchant' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Merchant',
                        component: () => import('@/views/front/brand/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create Merchant',
                        component: () => import('@/views/front/brand/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update Merchant',
                        component: () => import('@/views/front/brand/create.vue'),
                    },
                ],
            },
            {
                path: '/agent',
                name: 'Agent',
                redirect: '/agent/index',
                meta: { title: 'Agent' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Agent',
                        component: () => import('@/views/front/agent/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create Agent',
                        component: () => import('@/views/front/agent/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update Agent',
                        component: () => import('@/views/front/agent/create.vue'),
                    },
                ],
            },
            {
                path: '/user',
                name: 'User',
                redirect: '/user/index',
                meta: { title: 'User' },
                children: [
                    {
                        path: 'index',
                        name: 'Index User',
                        component: () => import('@/views/front/user/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create User',
                        component: () => import('@/views/front/user/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update User',
                        component: () => import('@/views/front/user/create.vue'),
                    },
                ],
            },
            {
                path: '/user_api',
                name: 'UserApi',
                redirect: '/user_api/index',
                meta: { title: 'User Api' },
                children: [
                    {
                        path: 'index',
                        name: 'Index User Api',
                        component: () => import('@/views/front/userApi/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create User Api',
                        component: () => import('@/views/front/userApi/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update User Api',
                        component: () => import('@/views/front/userApi/create.vue'),
                    },
                ],
            },
            {
                path: '/user_api_merchant',
                name: 'User API Merchant',
                redirect: '/user_api_merchant/index',
                meta: { title: 'User API Merchant' },
                children: [
                    {
                        path: 'index',
                        name: 'Index User API Merchant',
                        component: () => import('@/views/front/userApiMerchant/index.vue'),
                    },
                ],
            },
            {
                path: '/agent_bank_account',
                name: 'Agent Bank Account',
                redirect: '/agent_bank_account/index',
                meta: { title: 'Agent Bank Account' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Agent Bank Account',
                        component: () => import('@/views/front/agentBankAccount/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create Agent Bank Account',
                        component: () => import('@/views/front/agentBankAccount/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update Agent Bank Account',
                        component: () => import('@/views/front/agentBankAccount/create.vue'),
                    },
                ],
            },
            {
                path: '/transaction',
                name: 'Transaction',
                redirect: '/transaction/index',
                meta: { title: 'Transaction' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Transaction',
                        component: () => import('@/views/front/transaction/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create Transaction',
                        component: () => import('@/views/front/transaction/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update Transaction',
                        component: () => import('@/views/front/transaction/create.vue'),
                    },
                ],
            },
            {
                path: '/withdrawal',
                name: 'Withdrawal',
                redirect: '/withdrawal/index',
                meta: { title: 'Withdrawal' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Withdrawal',
                        component: () => import('@/views/front/withdrawal/index.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Withdrawal',
                        component: () => import('@/views/front/withdrawal/show.vue'),
                    },
                ],
            },
            {
                path: '/crypto_deposit',
                name: 'Crypto Deposit',
                redirect: '/crypto_deposit/index',
                meta: { title: 'Crypto Deposit' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Deposit',
                        component: () => import('@/views/front/cryptoDeposit/index.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Crypto Deposit',
                        component: () => import('@/views/front/cryptoDeposit/show.vue'),
                    },
                ],
            },
            {
                path: '/crypto_wallet',
                name: 'Crypto Wallets',
                redirect: '/crypto_wallet/index',
                meta: { title: 'Crypto Wallets' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Wallets',
                        component: () => import('@/views/front/cryptoWallet/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_payment',
                name: 'Crypto Payments',
                redirect: '/crypto_payment/index',
                meta: { title: 'Crypto Payments' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Payments',
                        component: () => import('@/views/front/cryptoPayment/index.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Crypto Payment',
                        component: () => import('@/views/front/cryptoPayment/show.vue'),
                    },
                    {
                        path: 'link/:id',
                        name: 'Show Crypto Payment Link',
                        component: () => import('@/views/front/cryptoPayment/linkShow.vue'),
                    },
                ],
            },
            {
                path: '/crypto_merchant_balance',
                name: 'Crypto Statements',
                redirect: '/crypto_merchant_balance/index',
                meta: { title: 'Crypto Statements' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Statements',
                        component: () => import('@/views/front/cryptoMerchantBalance/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_wallet_funds',
                name: 'Wallet Funds Overview',
                redirect: '/crypto_wallet_funds/index',
                meta: { title: 'Wallet Funds Overview' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Wallet Funds Overview',
                        component: () => import('@/views/front/cryptoWalletFunds/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_platform_fee',
                name: 'Crypto Platform Fees',
                redirect: '/crypto_platform_fee/index',
                meta: { title: 'Crypto Platform Fees' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Platform Fees',
                        component: () => import('@/views/front/cryptoPlatformFee/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_withdrawal',
                name: 'Crypto Withdrawals',
                redirect: '/crypto_withdrawal/index',
                meta: { title: 'Crypto Withdrawals' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Withdrawals',
                        component: () => import('@/views/front/cryptoWithdrawal/index.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Crypto Withdrawal',
                        component: () => import('@/views/front/cryptoWithdrawal/show.vue'),
                    },
                ],
            },
            {
                path: '/crypto_transfer',
                name: 'Crypto Transfer',
                redirect: '/crypto_transfer/index',
                meta: { title: 'Crypto Transfers' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Transfer',
                        component: () => import('@/views/front/cryptoTransfer/index.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Crypto Transfer',
                        component: () => import('@/views/front/cryptoTransfer/show.vue'),
                    },
                ],
            },
            {
                path: '/crypto_rates',
                name: 'Crypto Rates',
                redirect: '/crypto_rates/index',
                meta: { title: 'Crypto Rates' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Rates',
                        component: () => import('@/views/front/cryptoRates/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_health',
                name: 'Crypto Health',
                redirect: '/crypto_health/index',
                meta: { title: 'Crypto Health' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Health',
                        component: () => import('@/views/front/cryptoHealth/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_settings',
                name: 'Crypto Settings',
                redirect: '/crypto_settings/index',
                meta: { title: 'Crypto Settings' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Settings',
                        component: () => import('@/views/front/cryptoSettings/index.vue'),
                    },
                ],
            },
            {
                path: '/crypto_provider',
                name: 'Crypto Providers',
                redirect: '/crypto_provider/index',
                meta: { title: 'Crypto Providers' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Crypto Providers',
                        component: () => import('@/views/front/cryptoProvider/index.vue'),
                    },
                ],
            },
            {
                path: '/payment_gateway',
                name: 'Payment Gateway',
                redirect: '/payment_gateway/profiles',
                meta: { title: 'Payment Gateway' },
                children: [
                    {
                        path: 'index',
                        redirect: '/payment_gateway/profiles',
                    },
                    {
                        path: 'profiles',
                        name: 'Profiles',
                        component: () => import('@/views/front/paymentGateway/profiles.vue'),
                    },
                    {
                        path: 'health',
                        name: 'Provider Health',
                        component: () => import('@/views/front/paymentGateway/health.vue'),
                    },
                    {
                        path: 'rates',
                        name: 'Provider Rates',
                        component: () => import('@/views/front/paymentGateway/rates.vue'),
                    },
                    {
                        path: 'channels',
                        name: 'Channels',
                        component: () => import('@/views/front/paymentGateway/channels.vue'),
                    },
                    {
                        path: 'deposits',
                        name: 'Deposits',
                        component: () => import('@/views/front/paymentGateway/deposits.vue'),
                    },
                    {
                        path: 'deposits/:id',
                        name: 'Deposit Detail',
                        component: () => import('@/views/front/paymentGateway/depositShow.vue'),
                    },
                    {
                        path: 'withdrawals',
                        name: 'Withdrawals',
                        component: () => import('@/views/front/paymentGateway/withdrawals.vue'),
                    },
                    {
                        path: 'withdrawals/:id',
                        name: 'Withdrawal Detail',
                        component: () => import('@/views/front/paymentGateway/withdrawalShow.vue'),
                    },
                    {
                        path: 'callback-logs',
                        redirect: '/payment_gateway_callback_log',
                    },
                ],
            },
            {
                path: '/inquiries',
                name: 'Inquiries',
                redirect: '/inquiries/index',
                meta: { title: 'Inquiries' },
                children: [
                    {
                        path: 'index',
                        name: 'Index Inquiries',
                        component: () => import('@/views/front/inquiries/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create Inquiries',
                        component: () => import('@/views/front/inquiries/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update Inquiries',
                        component: () => import('@/views/front/inquiries/create.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show Inquiries',
                        component: () => import('@/views/front/inquiries/show.vue'),
                    },
                ],
            },
            {
                path: '/reporting',
                name: 'Reporting',
                redirect: '/reporting/inquiries',
                meta: { title: 'Reporting' },
                children: [
                    {
                        path: 'inquiries',
                        name: 'Inquiry Report',
                        component: () => import('@/views/front/reporting/inquiries.vue'),
                    },
                    {
                        path: 'withdrawals',
                        name: 'Withdrawal Report',
                        component: () => import('@/views/front/reporting/withdrawals.vue'),
                    },
                    {
                        path: 'crypto_deposits',
                        name: 'Crypto Deposit Report',
                        component: () => import('@/views/front/reporting/cryptoDeposits.vue'),
                    },
                ],
            },
            {
                path: '/license',
                name: 'License',
                redirect: '/license/index',
                meta: { title: 'License' },
                children: [
                    {
                        path: 'index',
                        name: 'Index License',
                        component: () => import('@/views/front/license/index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'Create License',
                        component: () => import('@/views/front/license/create.vue'),
                    },
                    {
                        path: 'update/:id',
                        name: 'Update License',
                        component: () => import('@/views/front/license/create.vue'),
                    },
                    {
                        path: 'show/:id',
                        name: 'Show License',
                        component: () => import('@/views/front/license/show.vue'),
                    },
                ],
            },
            {
                path: '/callback_log',
                name: 'Callback Log',
                component: () => import('@/views/front/callbackLog/index.vue'),
            },
            {
                path: '/withdrawal_callback_log',
                name: 'Withdrawal Callback Log',
                component: () => import('@/views/front/withdrawalCallbackLog/index.vue'),
            },
            {
                path: '/crypto_deposit_callback_log',
                name: 'Crypto Callback Log',
                component: () => import('@/views/front/cryptoDepositCallbackLog/index.vue'),
            },
            {
                path: '/crypto_withdrawal_callback_log',
                name: 'Crypto Withdrawal Callback Log',
                component: () => import('@/views/front/cryptoWithdrawalCallbackLog/index.vue'),
            },
            {
                path: '/payment_gateway_callback_log',
                name: 'Payment Gateway Callback Log',
                component: () => import('@/views/front/paymentGateway/callbackLogs.vue'),
            },
        ],
    },

    {
        path: '/example',
        name: 'Example',
        component: DefaultLayout,
        redirect: '/dashboard',
        children: [
            {
                path: '/home',
                name: 'Hom',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard.vue'),
            },
            {
                path: '/theme',
                name: 'Theme',
                redirect: '/theme/typography',
            },
            // {
            //   path: '/theme/colors',
            //   name: 'Colors',
            //   component: () => import('@/views/theme/Colors.vue'),
            // },
            {
                path: '/theme/typography',
                name: 'Typography',
                component: () => import('@/views/theme/Typography.vue'),
            },
            {
                path: '/base',
                name: 'Base',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                redirect: '/base/breadcrumbs',
                children: [
                    {
                        path: '/base/accordion',
                        name: 'Accordion',
                        component: () => import('@/views/base/Accordion.vue'),
                    },
                    {
                        path: '/base/breadcrumbs',
                        name: 'Breadcrumbs',
                        component: () => import('@/views/base/Breadcrumbs.vue'),
                    },
                    {
                        path: '/base/cards',
                        name: 'Cards',
                        component: () => import('@/views/base/Cards.vue'),
                    },
                    {
                        path: '/base/carousels',
                        name: 'Carousels',
                        component: () => import('@/views/base/Carousels.vue'),
                    },
                    {
                        path: '/base/collapses',
                        name: 'Collapses',
                        component: () => import('@/views/base/Collapses.vue'),
                    },
                    {
                        path: '/base/list-groups',
                        name: 'List Groups',
                        component: () => import('@/views/base/ListGroups.vue'),
                    },
                    {
                        path: '/base/navs',
                        name: 'Navs',
                        component: () => import('@/views/base/Navs.vue'),
                    },
                    {
                        path: '/base/paginations',
                        name: 'Paginations',
                        component: () => import('@/views/base/Paginations.vue'),
                    },
                    {
                        path: '/base/placeholders',
                        name: 'Placeholders',
                        component: () => import('@/views/base/Placeholders.vue'),
                    },
                    {
                        path: '/base/popovers',
                        name: 'Popovers',
                        component: () => import('@/views/base/Popovers.vue'),
                    },
                    {
                        path: '/base/progress',
                        name: 'Progress',
                        component: () => import('@/views/base/Progress.vue'),
                    },
                    {
                        path: '/base/spinners',
                        name: 'Spinners',
                        component: () => import('@/views/base/Spinners.vue'),
                    },
                    {
                        path: '/base/tables',
                        name: 'Tables',
                        component: () => import('@/views/base/Tables.vue'),
                    },
                    {
                        path: '/base/tabs',
                        name: 'Tabs',
                        component: () => import('@/views/base/Tabs.vue'),
                    },
                    {
                        path: '/base/tooltips',
                        name: 'Tooltips',
                        component: () => import('@/views/base/Tooltips.vue'),
                    },
                ],
            },
            {
                path: '/buttons',
                name: 'Buttons',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                redirect: '/buttons/standard-buttons',
                children: [
                    {
                        path: '/buttons/standard-buttons',
                        name: 'Button Component',
                        component: () => import('@/views/buttons/Buttons.vue'),
                    },
                    {
                        path: 'dropdowns',
                        name: 'Dropdowns',
                        component: () => import('@/views/buttons/Dropdowns.vue'),
                    },
                    {
                        path: '/buttons/button-groups',
                        name: 'Button Groups',
                        component: () => import('@/views/buttons/ButtonGroups.vue'),
                    },
                ],
            },
            {
                path: '/forms',
                name: 'Forms',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                redirect: '/forms/form-control',
                children: [
                    {
                        path: '/forms/form-control',
                        name: 'Form Control',
                        component: () => import('@/views/forms/FormControl.vue'),
                    },
                    {
                        path: '/forms/select',
                        name: 'Select',
                        component: () => import('@/views/forms/Select.vue'),
                    },
                    {
                        path: '/forms/checks-radios',
                        name: 'Checks & Radios',
                        component: () => import('@/views/forms/ChecksRadios.vue'),
                    },
                    {
                        path: '/forms/range',
                        name: 'Range',
                        component: () => import('@/views/forms/Range.vue'),
                    },
                    {
                        path: '/forms/input-group',
                        name: 'Input Group',
                        component: () => import('@/views/forms/InputGroup.vue'),
                    },
                    {
                        path: '/forms/floating-labels',
                        name: 'Floating Labels',
                        component: () => import('@/views/forms/FloatingLabels.vue'),
                    },
                    {
                        path: '/forms/layout',
                        name: 'Layout',
                        component: () => import('@/views/forms/Layout.vue'),
                    },
                    {
                        path: '/forms/validation',
                        name: 'Validation',
                        component: () => import('@/views/forms/Validation.vue'),
                    },
                ],
            },
            {
                path: '/charts',
                name: 'Charts',
                component: () => import('@/views/charts/Charts.vue'),
            },
            {
                path: '/icons',
                name: 'Icons',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                redirect: '/icons/coreui-icons',
                children: [
                    {
                        path: '/icons/coreui-icons',
                        name: 'CoreUI Icons',
                        component: () => import('@/views/icons/CoreUIIcons.vue'),
                    },
                    {
                        path: '/icons/brandssssss',
                        name: 'Brandsaaaa',
                        component: () => import('@/views/icons/Brands.vue'),
                    },
                    {
                        path: '/icons/flags',
                        name: 'Flags',
                        component: () => import('@/views/icons/Flags.vue'),
                    },
                ],
            },
            {
                path: '/notifications',
                name: 'Notifications',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                redirect: '/notifications/alerts',
                children: [
                    {
                        path: '/notifications/alerts',
                        name: 'Alerts',
                        component: () => import('@/views/notifications/Alerts.vue'),
                    },
                    {
                        path: '/notifications/badges',
                        name: 'Badges',
                        component: () => import('@/views/notifications/Badges.vue'),
                    },
                    {
                        path: '/notifications/modals',
                        name: 'Modals',
                        component: () => import('@/views/notifications/Modals.vue'),
                    },
                    {
                        path: '/notifications/toasts',
                        name: 'Toasts',
                        component: () => import('@/views/notifications/Toasts.vue'),
                    },
                ],
            },
            {
                path: '/widgets',
                name: 'Widgets',
                component: () => import('@/views/widgets/Widgets.vue'),
            },
        ],
    },
    {
        path: '/pages',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render() {
                return h(resolveComponent('router-view'))
            },
        },
        children: [
            {
                path: '404',
                name: 'Page404',
                component: () => import('@/views/pages/Page404'),
            },
            {
                path: '500',
                name: 'Page500',
                component: () => import('@/views/pages/Page500'),
            },
            // {
            //   path: 'login',
            //   name: 'Login',
            //   component: () => import('@/views/pages/Login'),
            // },
            {
                path: 'register',
                name: 'Register',
                component: () => import('@/views/pages/Register'),
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
    },
})
router.beforeEach(async (to, from) => {
    // console.log(to)
    const authStore = useAuthStore()
    if ((!to.meta.hasOwnProperty('auth') || to.meta.auth === true) && !authStore.isLoggedIn) {
        const loginSucces = await authStore.getCurrentUser()

        if (!loginSucces) {
            return { name: 'login' }
        }
    }
})
export default router

router.afterEach((to) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = 'Default Title'
    }
})
